import { inject, Injectable } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { LanguageService } from '../../../core/services/language.service';
import { MigrationDataService } from '../../services/migration-data.service';
import { ToastService } from '../../services/toast.service';
import { MigrationDataDialogComponent, MigrationDataDialogData } from './migration-data-dialog.component';


@Injectable({ providedIn: 'root' })
export class MigrationDataDialogService {
  private dialogService = inject(DialogService);
  private languageService = inject(LanguageService);
  private migrationDataService = inject(MigrationDataService);
  private toastService = inject(ToastService);

  private readonly WIDTH = '575px';

  public startMigrationOnInit(): void {
    if (this.migrationDataService.getDoNotAskAgainPromptOnInit()) return;

    this.migrationDataService.getMigrationStatus()
      .subscribe(({ migrationOpen, migrationInProgress }) => {
        if (migrationOpen && !migrationInProgress) {
          this.open({ onInit: true });
        }
      });
  }

  public startMigrationOnDemand(): void {
    this.migrationDataService.getMigrationStatus()
      .subscribe(({ migrationOpen, migrationInProgress }) => {
        if (migrationOpen && !migrationInProgress) {
          this.open({ onInit: false });
        } else {
          this.informAboutMigrationState(migrationOpen, migrationInProgress);
        }
      });
  }

  private open(data: MigrationDataDialogData): DynamicDialogRef<MigrationDataDialogComponent> {
    return this.dialogService.open(MigrationDataDialogComponent, {
      data,
      header: this.languageService.getInstant('revolution.shared.migration.migrationDialog.header'),
      width: this.WIDTH,
      focusOnShow: false,
      closable: false,
    });
  }

  private informAboutMigrationState(hasMigrationData: boolean, isMigrationInProgress: boolean): void {
    if (!hasMigrationData || isMigrationInProgress) {
      const summary = this.translate(isMigrationInProgress
        ? 'revolution.shared.migration.migrationInProgress'
        : 'revolution.shared.migration.migrationAlreadyDone'
      );
      this.toastService.showWarning({ summary });
    }
  }

  private translate(key: string): string {
    return this.languageService.getInstant(key);
  }
}
